export default (function galleryInit() {
    const isMobile = () => /Android|webOS|iPhone|iPad|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent);

    const gallery = {
        setImagesGroup() {
            // eslint-disable-next-line no-undef
            const arrayImages = galleryImages.sort((a, b) => a.position - b.position);
            const size = isMobile() ? 3 : 6;
            const subarray = [];
            // eslint-disable-next-line no-plusplus
            for (let i = 0; i < Math.ceil(arrayImages.length / size); i++) {
                subarray[i] = arrayImages.slice((i * size), (i * size) + size);
            }
            return subarray;
        },

        initSlider() {
            const images = gallery.setImagesGroup();
            const containerSlider = $('.js--gallery_slider');

            if (images && containerSlider && containerSlider.length) {
                // eslint-disable-next-line array-callback-return
                images.map((blockImages) => {
                    const arrayImages = blockImages.map(image => `<figure href="${image.original}"><a class="fancybox__gallery" rel="gallery_image_1" href="${image.original}"><img loading="lazy" src="${image.original}" /></a></figure>`);
                    containerSlider.append(`<div class="gallery_slider__slide"><div class="gallery_slider__slide_grid">${arrayImages.join('')}</div></div>`);
                });

                containerSlider.slick({
                    dots: images.length > 1 || isMobile(),
                    nextArrow: $('.js--gallery_slider__next'),
                    prevArrow: $('.js--gallery_slider__prev'),
                });
            }
        },
    };
    $(document).ready(() => {
        const galleryWrapper = $('.js--gallery_wrapper');
        if (galleryWrapper && galleryWrapper.length) {
            gallery.initSlider();
        }
    });
}());
